import { useContext } from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
// components
import { useSelector } from 'react-redux';
import { isLoggedAsCustomer } from 'src/selectors/uiSelectors';
import { useTranslation } from 'react-i18next';
import { ChatContext } from '../context/ChatContext';
import ContactsAutocomplete from './ContactsAutocomplete';
import MembersContactsAutocomplete from './MembersContactsAutocomplete';

export default function ChatHeaderCompose({
  conversation,
  contacts,
  recipients,
  onAddRecipients,
  showDetailsIcon = null,
}) {
  const { situation } = useContext(ChatContext);
  const isCustomer = useSelector(isLoggedAsCustomer);
  const { t } = useTranslation();

  if (isCustomer) return null;

  return (
    <RootStyle>
      <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
        {t('chat.to_addressee_text')}
      </Typography>
      <AutocompleteStyle>
        {situation || conversation.situationId ? (
          <MembersContactsAutocomplete
            situationId={situation?.id || conversation.situationId}
            contacts={contacts}
            recipients={recipients}
            onAddRecipients={onAddRecipients}
          />
        ) : (
          <ContactsAutocomplete
            contacts={contacts}
            recipients={recipients}
            onAddRecipients={onAddRecipients}
          />
        )}
      </AutocompleteStyle>
      <Box sx={{ flexGrow: 1 }} />
      {showDetailsIcon}
    </RootStyle>
  );
}

const RootStyle = styled('div')(({ theme }) => ({
  minHeight: 92,
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '1rem',
  padding: theme.spacing(2, 3),
}));

const AutocompleteStyle = styled('div')(({ theme }) => ({
  '& .MuiAutocomplete-root': {
    width: 240,
    flex: 'auto',
    '&.Mui-focused .MuiAutocomplete-inputRoot': {
      boxShadow: theme.customShadows.z8,
    },
    [theme.breakpoints.up('sm')]: {
      width: 280,
    },
  },
  '& .MuiAutocomplete-inputRoot': {
    transition: theme.transitions.create('box-shadow', {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.shorter,
    }),
    '& fieldset': {
      borderWidth: `1px !important`,
      borderColor: `${theme.palette.grey[500_32]} !important`,
    },
  },
}));
